export enum DaysRange {
    '30_DAYS' = '30_DAYS',
    '90_DAYS' = '90_DAYS',
    '180_DAYS' = '180_DAYS',
    '360_DAYS' = '360_DAYS'
}

export const DaysRangeLabels: Record<DaysRange, string> = {
    [DaysRange['30_DAYS']]: '30 Days',
    [DaysRange['90_DAYS']]: '90 Days',
    [DaysRange['180_DAYS']]: '180 Days',
    [DaysRange['360_DAYS']]: '360 Days'
};

export const DaysRangeToValues: Record<DaysRange, number> = {
    [DaysRange['30_DAYS']]: 30,
    [DaysRange['90_DAYS']]: 90,
    [DaysRange['180_DAYS']]: 180,
    [DaysRange['360_DAYS']]: 360,
};

